import React from 'react';
import MobileDetect from 'mobile-detect';


export default class FooterElement extends React.Component {
	 constructor(props) {
		var md = new MobileDetect(window.navigator.userAgent);
		super(props);
        this.state = {
        	isMobile: md.phone(),
        	isTablet: md.tablet()
        };
		this.buttonClick = this.buttonClick.bind(this);
	}

    buttonClick() {
        this.setState((prevState) => {
            return {
                visible: !prevState.visible
            }
        });
    }
    

	render() {

		return (
			<div>
				<div className="footer">
					<div className="container">
					{
						!this.props.saved && 
						<a  className="btn-information" onClick={this.buttonClick}><i className="icon-info"></i></a>
					}

					{
						this.props.editing && 
						<a onClick={this.props.onReset} className={"btn btn-brand hvr-float-shadow btn-reload" } ><i className="icon-delete" aria-hidden="true"></i> BORRAR TODO</a>
					}
					
					</div>
				</div>
				{
                    this.state.visible &&
					<div className="info-popup">
						<div className="container" >
							<div className="display-t"><div className="display-tc">
								<a  className="btn close" onClick={this.buttonClick}>&times;</a>
								<h2>¡Bienvenido a la Aventura Increíble!</h2>
								<p>Crear tu mundo de fantasía es muy fácil. </p>

								<p>Elige un fondo y un suelo con los botones de la izquierda.</p>

								<p>En los botones de la derecha encontrarás elementos de naturaleza y construcciones. Elige los que más te gusten, pincha sobre ellos, elige el tamaño y arrástralos al mapa donde tú consideres.<br/> 
								Ten en cuenta que no pueden superponerse.</p>

								<p>Al pulsar sobre los elementos elegidos podrás moverlos o eliminarlos todas las veces que quieras.</p>

								<p>Para terminar, con la ayuda de un adulto, solo falta hacer clic en GUARDA TU AVENTURA 
								para compartir tu diseño y participar en el concurso.</p>

								<p className="large">¡Mucha Suerte!	</p>


							</div></div>
						</div>
					</div>
				}

				{
					this.state.isMobile && 

					<div className="info-popup" id="mobileAlert">
						<div className="container" >
							<div className="display-t"><div className="display-tc">								
								
								<h2>¡Lo sentimos!</h2>							
								
								<p>Esta aplicación está optimizada para ordenador de sobremesa, portátil y tablet. Recomendamos su uso en estas plataformas.</p>

							</div></div>
						</div>	
					</div>
				}
				{
					this.state.isTablet && 

					<div className="info-popup" id="portraitAlert">
						<div className="container" >
							<div className="display-t"><div className="display-tc">								
								
								<h2>¡Lo sentimos!</h2>							

								<p>Para una mejor experiencia,<br/> pon tu tablet en posición horizontal</p>

							</div></div>
						</div>
					</div>
				}
			</div>

		);
	}

}


// WEBPACK FOOTER //
// ./src/FooterElement.js